<sl-label size="large" i18n>Customer Notifications</sl-label>

<sl-label class="mb-4" size="small" multiline color="medium" i18n>Defines how and when the notifications to your customers are sent. You can still customize it under each contact, but these are the standard settings.</sl-label>
    
<div class="grid" *ngIf="messagingSettings">
    <sl-label i18n multiline>Send Notifications Via</sl-label>
    <sl-well padding>
        <sl-list lines="full">
            <sl-list-item *ngFor="let method of deliveryMethods">
                <sl-label size="small">{{method.text}}</sl-label>
                <sl-switch slot="suffix" [(ngModel)]="method.state" (ngModelChange)="submit(method.value)"></sl-switch>
            </sl-list-item>
        </sl-list>
    </sl-well>

    <sl-label class="mt-4" i18n>Send Notifications Automatically When</sl-label>
    <sl-well padding>
        <sl-list lines="full">
            <sl-list-item *ngFor="let event of events">
                <sl-label size="small">{{event.text}}</sl-label>
                <div slot="suffix">
                    <sl-button size="small" (click)="editTemplate(event)" i18n>Edit template</sl-button>
                    <sl-switch class="ml-4" [(ngModel)]="event.state" (ngModelChange)="submit(event.value)"></sl-switch>
                </div>
                
            </sl-list-item>
        </sl-list>
    </sl-well>

    <sl-label class="mt-4" slot="header" i18n>Adjust notifications</sl-label>
    <sl-well padding>
        <sl-list lines="full">
            <sl-list-item>
                <sl-label size="small" i18n>Include service window in notifications</sl-label>
                <sl-switch slot="suffix" [(ngModel)]="messagingSettings!.notificationIncludesTime"
                    (ngModelChange)="submit('notificationIncludesTime')"></sl-switch>
            </sl-list-item>
            <sl-list-item>
                <sl-label size="small" i18n>Signature</sl-label>
                <sl-label size="x-small" color="dark" multiline i18n>Your signature will be added to the end of notifications sent to customers</sl-label>
                <sl-button slot="suffix" size="small" (click)="editSignature()" i18n>Edit signature</sl-button>
            </sl-list-item>
        </sl-list>

    </sl-well>
</div>

